import { render, staticRenderFns } from "./SwitchAnimal.vue?vue&type=template&id=3faab15a&"
import script from "./SwitchAnimal.vue?vue&type=script&lang=js&"
export * from "./SwitchAnimal.vue?vue&type=script&lang=js&"
import style0 from "./SwitchAnimal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports